<supplier-schedule-dialog
  *ngIf="visible"
  [(price)]="price"
  [finalBtnDisabled]="busy"
  [deploySupplierContext]="deploySupplierContext"
  [jobId]="job.id"
  [taskScheduleSource]="taskScheduleSource"
  [supplierId]="supplierId"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (confirm)="allocateJobToSupplier($event)"
  (scheduleChanged)="scheduleChanged($event)"
  (show)="onShow()"
  finalBtnText="Deploy"
  [referrPage]="referrPage"
>
  <div confirmation>
    <!--    <div class="mb-2">-->
    <!--      <carry-over-auth-->
    <!--        [organisationTypeId]="OrganisationTypeEnum.Engineius"-->
    <!--        [organisationId]="supplier.id"-->
    <!--        [taskScheduleChanges]="taskScheduleChanges"-->
    <!--        [jobId]="job.id"-->
    <!--      >-->
    <!--      </carry-over-auth>-->
    <!--    </div>-->
  </div>
</supplier-schedule-dialog>
<p-confirmDialog
  header="Confirmation"
  icon="pi pi-exclamation-triangle"
  key="allocate-job-to-supplier"
></p-confirmDialog>
